export default __webpack_public_path__ + "static/media/T_Carpet_Tiles.b24844d5.jpg";